import {
  Any,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class EulerService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static messageIndex(
    params: {
      /**  */
      submissionId?: string;
      /**  */
      submissionNumber?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Any[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoke/Euler/Message/Index';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { submissionId: params['submissionId'], submissionNumber: params['submissionNumber'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static messageGet(
    params: {
      /**  */
      submissionId?: string;
      /**  */
      submissionNumber?: string;
      /**  */
      typeName?: string;
      /**  */
      messageId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoke/Euler/Message';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        submissionId: params['submissionId'],
        submissionNumber: params['submissionNumber'],
        typeName: params['typeName'],
        messageId: params['messageId']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
